import { render, staticRenderFns } from "./hxwebsiteconsultgc.vue?vue&type=template&id=fcc1a63c&scoped=true&"
import script from "./hxwebsiteconsultgc.vue?vue&type=script&lang=js&"
export * from "./hxwebsiteconsultgc.vue?vue&type=script&lang=js&"
import style0 from "./hxwebsiteconsultgc.vue?vue&type=style&index=0&id=fcc1a63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc1a63c",
  null
  
)

export default component.exports